import React, { useState, useEffect } from "react";
import { TextField, Button, Typography, Box, Paper } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { guardarComprobante} from '../hooks/firebaseConfig'; // Ajusta la ruta según sea necesario

const Home = () => {
  const [dni, setDni] = useState("");
  const [result, setResult] = useState(null);
  const [consultaDate, setConsultaDate] = useState(null);
  const [ctoken,setCToken]=useState(null);
  const [loading, setLoading] = useState(false);
  // Simulamos que el usuario está autenticado (puedes usar un Context o Redux)
  const [isAuthenticated, setIsAuthenticated] = useState(true); 

  const navigate = useNavigate(); 

    // Verificar si el usuario está autenticado
    useEffect(() => {
      const token = localStorage.getItem("token");
      if (!token) {
        navigate("/login"); // Si no está autenticado, redirigimos al login
      }
    }, [navigate]);

  const handleSearch = async () => {
    const trimmedDni = dni.trim();
    
    if (!trimmedDni) {
      alert("Por favor ingrese un DNI válido");
      return;
    }

    setLoading(true);
    setResult(null);

    try {
      const response = await fetch("https://www.sistemacefamar.com.ar/api/padron/buscar", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          documento: trimmedDni
        }),
      });

      const data = await response.json();

      if (response.ok && data.success) {
        const afiliado = data.data;
        const token = `${Date.now()}-${Math.floor(Math.random() * 100000)}`;
        setCToken(token);
        
        setResult({
          encontrado: true,
          nombreCompleto: `${afiliado.apellido} ${afiliado.nombres}`,
          numeroAfiliado: afiliado.nroafiliado,
          parentesco: afiliado.parentesco,
          tipoAfiliado: afiliado.tipo_afiliado,
          domicilio: afiliado.domicilio,
          localidad: afiliado.localidad,
          fechaNacimiento: afiliado.fechanacim,
          tokenValidacion: token,
        });
        setConsultaDate(new Date().toLocaleString());
      } else {
        setResult({ encontrado: false });
        setConsultaDate(null);
      }
    } catch (error) {
      console.error("Error al consultar la API:", error);
      alert("Error de conexión. Por favor intente nuevamente.");
      setResult({ encontrado: false });
      setConsultaDate(null);
    } finally {
      setLoading(false);
    }
  };
 
  const handlePrint = async() => {
    if (!result || !result.encontrado) {
      alert("No hay datos para imprimir");
      return;
    }

    const fechaConsulta = new Date().toLocaleString();

    const comprobante = {
      dni: dni.trim(),
      nombre: result.nombreCompleto,
      numero_afiliado: result.numeroAfiliado,
      parentesco: result.parentesco,
      tipo_afiliado: result.tipoAfiliado,
      domicilio: result.domicilio,
      localidad: result.localidad,
      fecha_nacimiento: result.fechaNacimiento,
      fecha_consulta: fechaConsulta,
      token_validacion: ctoken,
    };

    try {
      const response = await fetch("https://sistemacefamar.com.ar/guardar-comprobante", {
          method: "POST",
          headers: {
              "Content-Type": "application/json",
              "Accept": "application/json",
          },
          body: JSON.stringify(comprobante),
      });

      const data = await response.json();

      if (data.success) {
          console.log("Comprobante guardado:", data.comprobante);
          guardarComprobante(comprobante);
          window.print();
      } else {
          console.error("Error al guardar el comprobante:", data);
          alert("Hubo un error al guardar el comprobante.");
      }
    } catch (error) {
        console.error("Error en la petición:", error);
        alert("No se pudo conectar con el servidor.");
    }
  };

  const handleLogout = () => {
    setIsAuthenticated(false);
    localStorage.removeItem("token");
    navigate("/login"); // Redirigir a login
  };

  if (!isAuthenticated) {
    return null; // Si no está autenticado, no renderiza el contenido de Home
  }

  return (
    <Paper elevation={3} sx={{ p: 4, maxWidth: 600, mx: "auto", mt: 8 }}>
      {/* Ocultar el título al imprimir */}
      <Box sx={{ "@media print": { display: "none" } }}>
        <Typography variant="h5" textAlign="center" gutterBottom>
          Consultar DNI
        </Typography>
      </Box>
      <Box display="flex" flexDirection="column" gap={2}>
        <Box sx={{ "@media print": { display: "none" } }}>
        <TextField
          label="Ingrese el DNI"
          variant="outlined"
          value={dni}
          onChange={(e) => setDni(e.target.value)}
          fullWidth
          sx={{ mb: 2}}
          disabled={loading}
        />
        <Button 
          variant="contained" 
          color="primary" 
          onClick={handleSearch}
          disabled={loading}
        >
          {loading ? "Consultando..." : "Consultar"}
        </Button>
        </Box>
        {/* {result && result.encontrado && (
          <Box sx={{ mt: 2, p: 2, border: "1px solid", borderColor: "grey.300", borderRadius: 2 }}>
            <Typography variant="h6">AFILIADO VIGENTE</Typography>
            <Typography>
              <strong>Nombre completo:</strong> {result.nombreCompleto}
            </Typography>
            <Typography>
              <strong>Número de afiliado:</strong> {result.numeroAfiliado}
            </Typography>
            <Typography>
              <strong>Cobertura en medicamentos:</strong> 40%
            </Typography>
            <Typography>
              <strong>Vigencia:</strong> {result.vigencia}
            </Typography>
            {consultaDate && (
              <Typography>
                <strong>Consulta realizada el:</strong> {consultaDate.toLocaleString()}
              </Typography>
            )}
            <Button variant="contained" color="success" onClick={handlePrint} sx={{ mt: 2 }}>
              Imprimir comprobante
            </Button>
          </Box>
        )}
        {result && !result.encontrado && (
          <Typography variant="body1" color="error" sx={{ mt: 2 }}>
            El DNI ingresado no corresponde a ningún afiliado activo.
          </Typography>
        )} */}
        {/* Muestra los datos solo si hay un resultado */}
        {result && (
          <Box id="comprobante" sx={{ mt: 2, p: 2, border: "1px solid grey", borderRadius: 2 }}>
            {result.encontrado ? (
              <>
                <Typography variant="h6"><strong>CONSTANCIA DE AFILIACION MUTUAL 22 DE DICIEMBRE</strong></Typography>
                <Typography sx={{ fontSize: "20px", fontWeight: "bold" }}><strong>AFILIADO VIGENTE</strong></Typography>
                <Typography><strong>Nombre completo:</strong> {result.nombreCompleto}</Typography>
                <Typography><strong>Número de afiliado:</strong> {result.numeroAfiliado}</Typography>
                <Typography><strong>Parentesco:</strong> {result.parentesco}</Typography>
                {result.tipoAfiliado && (
                  <Typography><strong>Tipo de afiliado:</strong> {result.tipoAfiliado}</Typography>
                )}
                <Typography><strong>Domicilio:</strong> {result.domicilio}</Typography>
                <Typography><strong>Localidad:</strong> {result.localidad}</Typography>
                <Typography><strong>Fecha de nacimiento:</strong> {result.fechaNacimiento}</Typography>
                <Typography><strong>Cobertura en medicamentos:</strong> 40%</Typography>
                <Typography><strong>Fecha y hora de consulta:</strong> {consultaDate}</Typography>
                <Typography><strong>Favor de adjuntar la presente a la facturacion.</strong></Typography>
                <Typography><strong>Token de Validación:</strong> {result.tokenValidacion}</Typography>
                <Button variant="contained" color="success" onClick={handlePrint} sx={{ mt: 2, "@media print": { display: "none" } }}>
                  Imprimir Comprobante
                </Button>
              </>
            ) : (
              <Typography variant="body1" color="error">
                El DNI ingresado no corresponde a ningún afiliado activo.
              </Typography>
            )}
          </Box>
        )}
        <Button variant="contained" color="secondary" onClick={handleLogout} sx={{ "@media print": { display: "none" } }}>
          Cerrar sesión
        </Button>
      </Box>
    </Paper>
  );
};

export default Home;
